import { render, staticRenderFns } from "./AddressDetailStats.vue?vue&type=template&id=12f96be5&scoped=true"
import script from "./AddressDetailStats.vue?vue&type=script&lang=js"
export * from "./AddressDetailStats.vue?vue&type=script&lang=js"
import style0 from "./AddressDetailStats.vue?vue&type=style&index=0&id=12f96be5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f96be5",
  null
  
)

export default component.exports